import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ICondicionesMovimientos } from '../interfaces/CondicionesMovimientos';
import { CondicionesMovimientosService } from '../Services/condiciones-movimientos.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-condiciones-movimientos',
  templateUrl: './condiciones-movimientos.component.html',
  styleUrls: ['./condiciones-movimientos.component.css']
})
export class CondicionesMovimientosComponent implements OnInit {

  public condicionesMovimientosList: ICondicionesMovimientos[];


  public term: string;

  constructor(
      private condicionesMovimientosService: CondicionesMovimientosService,
      private router: Router
    ) { }

  ngOnInit(): void {
    this.load();
  }

  private load() {
    this.condicionesMovimientosService.getAll()
      .then(condicionesMovimientos => this.condicionesMovimientosList = condicionesMovimientos);
  }

  public addCondicion() {
    this.router.navigate(['/home/registro/form', 'add', '']);
  }

  public editCondicion(id: number) {
    this.router.navigate(['/home/registro/form', 'edit', id]);
  }

  public deleteCondicion(id: number) {
    Swal.fire({
      text: 'Estás seguro que deseas eliminar esta condición?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si',
      cancelButtonText: 'No. Cancelar',
    })
    .then(result => {
      if(result.isConfirmed) {
        return this.condicionesMovimientosService.delete(id);
      }
    })
    .then(() => {
      this.load();
    });
  }
}
